module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_2-ddbf4fac8a5edbfd431e5c01d0643cf2.svg";